export default __webpack_public_path__ + "static/media/yuri.af41947c.jpg";